const listMode = {
    list : 'LIST',
    page : 'PAGE',
};

const orderby = {
    CAREER: 'CAREER',
    RANDOM: 'RANDOM',
    MAIN: 'DISTANCE',
};

const sort = {
    ASC : 'ASC',
    DESC : 'DESC',
};

export {
    listMode,
    orderby,
    sort
}